import { useState } from 'react';
import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import DataTabs from '@rio-cloud/rio-uikit/DataTabs';
import DataTab from '@rio-cloud/rio-uikit/DataTab';
import useScoreExtractStore from '../services/scoreExtractStore';
import { useNavigate } from 'react-router';
import { useSelectVehicleStore } from '../services/selectVehicleSlice';
import DashboardTableInfractions from '../features/dashboardTableInfractions/DashboardTableInfractions';
import DashboardTableAnalysis from '../features/dashboardTableAnalysis/DashBoardTableAnalysis';
import TableViewToggles from '@rio-cloud/rio-uikit/components/table/TableViewToggles';
import { RouteMap } from '../routes/routeList';


const Title = ({ text, icon, value }: { text: string; icon: React.ReactNode, value: React.ReactNode }) => (
    <div>
        <div>{text}</div>
        <div className='text-bold text-size-18'><span className={`rioglyph ${icon} margin-right-10`}></span>{value}</div>
    </div>
);

export default function Predictive() {

    const [tabKey, setTabKey] = useState<string>('');
    const { clearExtractScoreData } = useScoreExtractStore();
    const { clearSelectedVehicle } = useSelectVehicleStore();
    const navigate = useNavigate();
    const { selectedVehicle } = useSelectVehicleStore();
    const behaviorType = 'PREDICTIVE';
    const behaviorRoute = `/${RouteMap.get('behavior')}`;
    
    const tabs = [
        {
            key: 'IT_EXTRACT',
            icon: 'rioglyph-clipboard',
            title: 'Preditivo',
            value: 'Análise por Evento',
            hasData: true
        },
        {
            key: 'IT_KICKDOWN',
            icon: 'rioglyph-kickdown',
            title: 'Aceleração',
            value: `${selectedVehicle.itKickdown || 0} Ocorrências`,
            hasData: selectedVehicle.itKickdown ? Number(selectedVehicle.itKickdown) > 0 : false
        },
        {
            key: 'IT_ACCELERATION',
            icon: 'rioglyph-tire',
            title: 'Partida',
            value: `${selectedVehicle.itAcceleration || 0} Ocorrências`,
            hasData: selectedVehicle.itAcceleration ? Number(selectedVehicle.itAcceleration) > 0 : false
        },
        {
            key: 'IT_RPM',
            icon: 'rioglyph-engine',
            title: 'Rotação do Motor',
            value: `${selectedVehicle.itRpm || 0} Ocorrências`,
            hasData: selectedVehicle.itRpm ? Number(selectedVehicle.itRpm) > 0 : false
        },
        {
            key: 'IT_CLUTCH',
            icon: 'rioglyph-kickdown',
            title: 'Uso da Embreagem',
            value: `${selectedVehicle.itClutch || 0} Ocorrências`,
            hasData: selectedVehicle.itClutch ? Number(selectedVehicle.itClutch) > 0 : false
        },
        {
            key: 'IT_OPERATIONAL_INSISTENCE',
            icon: 'rioglyph-dangerousgoods',
            title: 'Insistência Operacional',
            value: `${selectedVehicle.itOperationalInsistence || 0} Ocorrências`,
            hasData: selectedVehicle.itOperationalInsistence ? Number(selectedVehicle.itOperationalInsistence) > 0 : false
        },
    ];

    return (
        <StatsWidgets>
            <StatsWidget>
                <StatsWidget.Header className='text-left text-size-16'>
                    <ul className="breadcrumb">
                        <li>
                            <span className="btn btn-link btn-link-inline">
                                <span className="rioglyph rioglyph-home margin-right-0">
                                </span>
                                <span className='margin-left-10'>
                                    <a onClick={()=>{
                                        clearExtractScoreData();
                                        clearSelectedVehicle();
                                        navigate(behaviorRoute);
                                    }}>Comportamento</a>
                                </span>
                            </span>
                        </li>
                        <li className="active">Preditivoㅤ-ㅤ<span className='text-bold'>{ selectedVehicle.name }</span></li>
                    </ul>
                </StatsWidget.Header>
                <StatsWidget.Body>
                    <DataTabs activeKey={tabKey} onSelectTab={newTabKey => setTabKey(newTabKey)}>
                        {tabs.map((tab, index) => {
                            if (index === 0) {
                                return (
                                    <DataTab key={index} active={true} tabKey={tab.key} title={<Title text={tab.value} icon={tab.icon} value={tab.title} />}>
                                        <DashboardTableAnalysis viewType={TableViewToggles.VIEW_TYPE_TABLE} behaviorType={behaviorType} />
                                    </DataTab>
                                )
                            } else {
                                return (<DataTab key={index} tabKey={tab.key} title={<Title text={tab.value} icon={tab.icon} value={tab.title} />}>
                                    <DashboardTableInfractions viewType={TableViewToggles.VIEW_TYPE_TABLE} hasData={tab.hasData} infractionName={tab.key} tabName={tab.title}/>
                                </DataTab>)
                            }
                        })}
                    </DataTabs>
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    );
}